export function countryIdMutator([countryName], state, { changeValue }) {
  changeValue(state, 'countryName', () => countryName);
  // changeValue(state, 'address', () => countryName);
}

export function addressMutator([address], state, { changeValue }) {
  changeValue(state, 'address', () => address);
}

export function coordsMutator([{ lat, lng }], state, { changeValue }) {
  changeValue(state, 'latitude', () => lat);
  changeValue(state, 'longitude', () => lng);

  changeValue(state, 'coords', () => {
    if (lat !== null && lng !== null) {
      return [lat, lng].join(', ');
    }
    return '';
  });
}
